import { useParams } from "wouter";
import { Card } from "../../ui/Card";
import { PageHeader } from "./shared";

const BUCKETS = [
  { id: "pendingApproval", label: "Pending approval" },
  { id: "approved", label: "Approved" },
  { id: "paid", label: "Paid" },
] as const;

/**
 * Invoices page (honest state).
 *
 * Observed endpoints we tried:
 *   - GET /services/invoices/bulk → 404 (wrong path for this market)
 *
 * The correct path is somewhere in docs/observed/events.json — needs a
 * dedicated re-trace pass before binding. Until then, the page declares
 * what we know and routes the user to Aiko.
 */
export function Invoices() {
  const params = useParams<{ bucket?: string }>();
  const active = params.bucket ?? "pendingApproval";
  return (
    <div className="space-y-6">
      <PageHeader title="Invoices" subtitle="Supplier invoices and payment status." />
      <nav className="flex gap-1 border-b border-line">
        {BUCKETS.map((b) => (
          <a
            key={b.id}
            href={`/app/invoices/${b.id}`}
            className={
              "px-4 py-2 text-sm transition border-b-2 -mb-px " +
              (active === b.id
                ? "border-nomni-green text-spinach font-medium"
                : "border-transparent text-ink-2 hover:text-ink")
            }
          >
            {b.label}
          </a>
        ))}
      </nav>
      <Card tone="warn">
        <h3 className="font-medium text-ink mb-2">Observed endpoints, not yet bound</h3>
        <p className="text-sm text-ink-2 mb-3">
          The exact invoice list path for "{active}" isn't in the observed-trace bind yet (the canonical /services/invoices/bulk returns 404 for this market). Aiko knows your invoices through the chat surface; the dedicated page lands next pass.
        </p>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            window.dispatchEvent(
              new CustomEvent("aiko:ask", { detail: `List my ${active} invoices` }),
            );
          }}
          className="inline-flex items-center gap-1.5 rounded-md bg-nomni-green text-canvas-2 px-3 py-1.5 text-sm font-medium hover:brightness-110 transition"
        >
          ✦ Ask Aiko for this view
        </a>
      </Card>
    </div>
  );
}
